var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4.57143,
    fill: "#FEA844",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_1695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2494 11.5353C23.9709 11.4099 23.6617 11.3691 23.3602 11.418C23.0587 11.4669 22.7782 11.6033 22.5536 11.8103L20.5828 13.6436V12.3145C20.5828 11.5851 20.293 10.8856 19.7773 10.3699C19.2616 9.85418 18.5621 9.56445 17.8328 9.56445H9.58276C8.85342 9.56445 8.15395 9.85418 7.63822 10.3699C7.1225 10.8856 6.83276 11.5851 6.83276 12.3145V19.6478C6.83276 20.3771 7.1225 21.0766 7.63822 21.5923C8.15395 22.1081 8.85342 22.3978 9.58276 22.3978H17.8328C18.5621 22.3978 19.2616 22.1081 19.7773 21.5923C20.293 21.0766 20.5828 20.3771 20.5828 19.6478V18.3186L22.5628 20.152C22.8543 20.4158 23.2329 20.5627 23.6261 20.5645C23.8443 20.5639 24.0599 20.5171 24.2586 20.427C24.529 20.3176 24.7606 20.1301 24.9239 19.8884C25.0871 19.6468 25.1747 19.3619 25.1753 19.0703V12.892C25.1739 12.5992 25.0851 12.3136 24.9201 12.0719C24.7551 11.8301 24.5215 11.6432 24.2494 11.5353Z",
    fill: "#FEA844"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_1695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFileIcon);
export default __webpack_public_path__ + "static/media/video-file-icon.0bea58bb5e7e8c4bf7f051a17a07dad1.svg";
export { ForwardRef as ReactComponent };